import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Search, ArrowLeft, ExternalLink, Ticket, CreditCard, Database, X, Calendar, ChevronDown, Send, MessageSquare } from 'lucide-react';
interface DataRecord {
  id: string;
  title: string;
  source: 'Jira' | 'QuickBooks' | 'Calendar';
  recordType: string;
  synced: string;
  badge?: string;
  badgeColor?: string;
  project?: string;
  fields: {
    label: string;
    value: string;
    editable?: boolean;
    options?: string[];
  }[];
}
const RECORDS: DataRecord[] = [{
  id: '1',
  title: 'ZEN-142: Rate limiting for /sync endpoint',
  source: 'Jira',
  recordType: 'Bug',
  synced: '2h ago',
  badge: 'Bug',
  badgeColor: 'text-red-400',
  project: 'ZEN',
  fields: [{
    label: 'Status',
    value: 'In Progress',
    editable: true,
    options: ['To Do', 'In Progress', 'In Review', 'Done']
  }, {
    label: 'Assignee',
    value: 'Tom',
    editable: true,
    options: ['Matt', 'Tom', 'Lisa', 'Sarah', 'Unassigned']
  }, {
    label: 'Priority',
    value: 'High',
    editable: true,
    options: ['Highest', 'High', 'Medium', 'Low']
  }, {
    label: 'Sprint',
    value: 'Sprint 22',
    editable: true,
    options: ['Sprint 21', 'Sprint 22', 'Sprint 23', 'Backlog']
  }, {
    label: 'Story Points',
    value: '5',
    editable: true
  }, {
    label: 'Created',
    value: '2026-04-03'
  }]
}, {
  id: '2',
  title: 'ZEN-138: SSL cert renewal automation',
  source: 'Jira',
  recordType: 'Task',
  synced: '5h ago',
  badge: 'Task',
  project: 'ZEN',
  fields: [{
    label: 'Status',
    value: 'In Review',
    editable: true,
    options: ['To Do', 'In Progress', 'In Review', 'Done']
  }, {
    label: 'Assignee',
    value: 'Lisa',
    editable: true,
    options: ['Matt', 'Tom', 'Lisa', 'Sarah', 'Unassigned']
  }, {
    label: 'Priority',
    value: 'High',
    editable: true,
    options: ['Highest', 'High', 'Medium', 'Low']
  }, {
    label: 'Sprint',
    value: 'Sprint 22'
  }, {
    label: 'Story Points',
    value: '3',
    editable: true
  }, {
    label: 'Created',
    value: '2026-04-01'
  }]
}, {
  id: '3',
  title: 'ZEN-135: Nango webhook pipeline',
  source: 'Jira',
  recordType: 'Story',
  synced: 'yesterday',
  badge: 'Story',
  badgeColor: 'text-green-400',
  project: 'ZEN',
  fields: [{
    label: 'Status',
    value: 'Done',
    editable: true,
    options: ['To Do', 'In Progress', 'In Review', 'Done']
  }, {
    label: 'Assignee',
    value: 'Matt',
    editable: true,
    options: ['Matt', 'Tom', 'Lisa', 'Sarah', 'Unassigned']
  }, {
    label: 'Priority',
    value: 'Medium',
    editable: true,
    options: ['Highest', 'High', 'Medium', 'Low']
  }, {
    label: 'Sprint',
    value: 'Sprint 22'
  }, {
    label: 'Story Points',
    value: '8',
    editable: true
  }, {
    label: 'Created',
    value: '2026-03-25'
  }]
}, {
  id: '4',
  title: 'TMA-89: Patient onboarding redesign',
  source: 'Jira',
  recordType: 'Story',
  synced: 'yesterday',
  badge: 'Story',
  badgeColor: 'text-green-400',
  project: 'TMA',
  fields: [{
    label: 'Status',
    value: 'To Do',
    editable: true,
    options: ['To Do', 'In Progress', 'In Review', 'Done']
  }, {
    label: 'Assignee',
    value: 'Unassigned',
    editable: true,
    options: ['Matt', 'Tom', 'Lisa', 'Sarah', 'Unassigned']
  }, {
    label: 'Priority',
    value: 'Medium',
    editable: true,
    options: ['Highest', 'High', 'Medium', 'Low']
  }, {
    label: 'Sprint',
    value: 'Backlog'
  }, {
    label: 'Story Points',
    value: '13',
    editable: true
  }, {
    label: 'Created',
    value: '2026-03-20'
  }]
}, {
  id: '5',
  title: 'INV-2026-041: Hetzner Hosting',
  source: 'QuickBooks',
  recordType: 'Invoice',
  synced: 'today',
  badge: '\u00a347.20',
  fields: [{
    label: 'Status',
    value: 'Paid'
  }, {
    label: 'Vendor',
    value: 'Hetzner Online GmbH'
  }, {
    label: 'Category',
    value: 'Infrastructure'
  }, {
    label: 'Date',
    value: '2026-04-01'
  }, {
    label: 'Due Date',
    value: '2026-04-15'
  }, {
    label: 'Tax',
    value: '\u00a39.44'
  }]
}, {
  id: '6',
  title: 'INV-2026-039: OpenAI API',
  source: 'QuickBooks',
  recordType: 'Invoice',
  synced: 'Mon',
  badge: '\u00a3156.80',
  fields: [{
    label: 'Status',
    value: 'Paid'
  }, {
    label: 'Vendor',
    value: 'OpenAI Inc.'
  }, {
    label: 'Category',
    value: 'AI / APIs'
  }, {
    label: 'Date',
    value: '2026-03-31'
  }, {
    label: 'Due Date',
    value: '2026-04-14'
  }, {
    label: 'Tax',
    value: '\u00a30.00'
  }]
}, {
  id: '7',
  title: 'Team standup',
  source: 'Calendar',
  recordType: 'Recurring',
  synced: 'today',
  badge: '15 min',
  fields: [{
    label: 'Time',
    value: '9:00 AM daily'
  }, {
    label: 'Recurrence',
    value: 'Every weekday'
  }, {
    label: 'Attendees',
    value: 'Matt, Tom, Lisa, Sarah'
  }, {
    label: 'Location',
    value: 'Google Meet'
  }, {
    label: 'Calendar',
    value: 'Work'
  }]
}, {
  id: '8',
  title: 'Q2 budget review',
  source: 'Calendar',
  recordType: 'Meeting',
  synced: 'today',
  badge: '45 min',
  fields: [{
    label: 'Time',
    value: '11:00 AM today'
  }, {
    label: 'Attendees',
    value: 'Sarah, James'
  }, {
    label: 'Location',
    value: 'Meeting Room 2'
  }, {
    label: 'Calendar',
    value: 'Work'
  }]
}, {
  id: '9',
  title: 'Acme Corp partnership call',
  source: 'Calendar',
  recordType: 'Meeting',
  synced: 'today',
  badge: '30 min',
  fields: [{
    label: 'Time',
    value: '2:00 PM today'
  }, {
    label: 'Attendees',
    value: 'James Wright (Acme)'
  }, {
    label: 'Location',
    value: 'Zoom'
  }, {
    label: 'Notes',
    value: 'Review contract section 4.2'
  }]
}];
const SOURCE_ICONS: Record<string, React.FC<{
  size?: number;
  className?: string;
}>> = {
  Jira: Ticket,
  QuickBooks: CreditCard,
  Calendar: Calendar
};
const TABS = ['All', 'Jira', 'QuickBooks', 'Calendar'] as const;
const JIRA_FILTERS: Record<string, string[]> = {
  Project: ['ZEN', 'TMA', 'INFRA'],
  Type: ['Bug', 'Story', 'Task', 'Epic'],
  Status: ['To Do', 'In Progress', 'In Review', 'Done'],
  Priority: ['Highest', 'High', 'Medium', 'Low']
};
const QB_FILTERS: Record<string, string[]> = {
  Type: ['Invoice', 'Payment', 'Transaction', 'Company'],
  Status: ['Paid', 'Pending', 'Overdue', 'Processed'],
  Category: ['Infrastructure', 'AI / APIs', 'Salaries', 'SaaS']
};
const CAL_FILTERS: Record<string, string[]> = {
  Type: ['Meeting', 'Recurring', 'Personal', 'All-day'],
  Calendar: ['Work', 'Personal'],
  When: ['Today', 'This week', 'Next 7 days']
};
type FilterState = Record<string, string[]>;
function FilterPills({
  filters,
  activeFilters,
  onToggle
}: {
  filters: Record<string, string[]>;
  activeFilters: FilterState;
  onToggle: (c: string, v: string) => void;
}) {
  return <div className="flex flex-wrap gap-x-6 gap-y-3 mb-6" data-id="element-715">
      {Object.entries(filters).map(([cat, vals]) => <div key={cat} className="flex items-center gap-2 flex-wrap" data-id="element-716">
          <span className="text-[12px] text-[#8a8680]/50 uppercase tracking-wider" data-id="element-717">{cat}</span>
          {vals.map(v => {
        const a = (activeFilters[cat] || []).includes(v);
        return <button key={v} onClick={() => onToggle(cat, v)} className={`text-[13px] px-2.5 py-1 rounded-full transition-colors ${a ? 'bg-[#4a9a9a]/20 text-[#4a9a9a]' : 'bg-[#252530] text-[#8a8680] hover:text-[#e8e4df]'}`} data-id="element-718">{v}{a && <X size={10} className="inline ml-1.5 -mt-0.5" data-id="element-719" />}</button>;
      })}
        </div>)}
    </div>;
}
export function DataView() {
  const [search, setSearch] = useState('');
  const [activeTab, setActiveTab] = useState<string>('All');
  const [viewingId, setViewingId] = useState<string | null>(null);
  const [activeFilters, setActiveFilters] = useState<FilterState>({});
  const toggleFilter = (c: string, v: string) => {
    setActiveFilters(prev => {
      const cur = prev[c] || [];
      return {
        ...prev,
        [c]: cur.includes(v) ? cur.filter(x => x !== v) : [...cur, v]
      };
    });
  };
  if (viewingId) {
    const rec = RECORDS.find(r => r.id === viewingId);
    if (rec) return <RecordDetail record={rec} onBack={() => setViewingId(null)} data-id="element-720" />;
  }
  const currentFilters = activeTab === 'Jira' ? JIRA_FILTERS : activeTab === 'QuickBooks' ? QB_FILTERS : activeTab === 'Calendar' ? CAL_FILTERS : null;
  const hasActive = Object.values(activeFilters).some(v => v.length > 0);
  const filtered = RECORDS.filter(r => {
    if (activeTab !== 'All' && r.source !== activeTab) return false;
    if (search && !r.title.toLowerCase().includes(search.toLowerCase())) return false;
    if (!hasActive) return true;
    for (const [cat, vals] of Object.entries(activeFilters)) {
      if (vals.length === 0) continue;
      if (cat === 'Project' && r.project && !vals.includes(r.project)) return false;
      if (cat === 'Type' && !vals.includes(r.recordType)) return false;
      if (cat === 'Status') {
        const f = r.fields.find(f => f.label === 'Status');
        if (f && !vals.includes(f.value)) return false;
      }
      if (cat === 'Priority') {
        const f = r.fields.find(f => f.label === 'Priority');
        if (f && !vals.includes(f.value)) return false;
      }
      if (cat === 'Category') {
        const f = r.fields.find(f => f.label === 'Category');
        if (f && !vals.includes(f.value)) return false;
      }
      if (cat === 'Calendar') {
        const f = r.fields.find(f => f.label === 'Calendar');
        if (f && !vals.includes(f.value)) return false;
      }
    }
    return true;
  });
  return <div className="min-h-[calc(100vh-56px)] text-[#e8e4df] selection:bg-[#4a9a9a]/30 pt-12 pb-32 px-6" data-id="element-721">
      <div className="max-w-[640px] mx-auto w-full flex flex-col" data-id="element-722">
        <header className="mb-6" data-id="element-723"><h1 className="text-[20px] font-bold text-[#e8e4df] tracking-tight mb-1" data-id="element-724">Data</h1><p className="text-[#8a8680] text-[14px]" data-id="element-725">Synced records from Jira, QuickBooks, Calendar, and other sources.</p></header>
        <div className="relative mb-6" data-id="element-726"><Search size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-[#8a8680]/50" data-id="element-727" /><input type="text" value={search} onChange={e => setSearch(e.target.value)} placeholder="Search records..." className="w-full bg-[#1c1c22] text-[#e8e4df] rounded-[12px] pl-11 pr-4 py-3 text-[15px] outline-none placeholder:text-[#8a8680]/40 focus:ring-1 focus:ring-[#4a9a9a]/30" data-id="element-728" /></div>
        <nav className="flex items-center gap-6 mb-5 border-b border-[#8a8680]/10" data-id="element-729">
          {TABS.map(tab => {
          const isActive = activeTab === tab;
          return <button key={tab} onClick={() => {
            setActiveTab(tab);
            setActiveFilters({});
          }} className={`pb-3 text-[14px] font-medium transition-colors relative ${isActive ? 'text-[#e8e4df]' : 'text-[#8a8680] hover:text-[#e8e4df]/80'}`} data-id="element-730">{tab}{isActive && <motion.div layoutId="dataTabIndicator" className="absolute bottom-0 left-0 right-0 h-[2px] bg-[#4a9a9a]" initial={false} transition={{
              type: 'spring',
              stiffness: 500,
              damping: 30
            }} data-id="element-731" />}</button>;
        })}
        </nav>
        {currentFilters && <FilterPills filters={currentFilters} activeFilters={activeFilters} onToggle={toggleFilter} data-id="element-732" />}
        <div className="flex flex-col gap-3" data-id="element-733">
          {filtered.map((rec, i) => {
          const Icon = SOURCE_ICONS[rec.source] || Database;
          return <motion.button key={rec.id} initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.3,
            delay: i * 0.04
          }} onClick={() => setViewingId(rec.id)} className="bg-[#1c1c22] rounded-[16px] p-5 shadow-xl shadow-black/20 text-left group hover:bg-[#1e1e25] transition-colors w-full" data-id="element-734">
              <div className="flex items-center gap-4" data-id="element-735"><div className="w-10 h-10 rounded-[12px] bg-[#252530] flex items-center justify-center shrink-0" data-id="element-736"><Icon size={18} className="text-[#8a8680]" data-id="element-737" /></div><div className="flex-1 min-w-0" data-id="element-738"><h2 className="text-[#e8e4df] font-medium text-[15px] truncate" data-id="element-739">{rec.title}</h2><p className="text-[#8a8680]/60 text-[13px] mt-0.5" data-id="element-740">{rec.source} {rec.recordType}</p></div><div className="flex items-center gap-3 shrink-0" data-id="element-741">{rec.badge && <span className={`text-[12px] bg-[#252530] px-2 py-0.5 rounded-full ${rec.badgeColor || 'text-[#8a8680]/60'}`} data-id="element-742">{rec.badge}</span>}<span className="text-[12px] text-[#8a8680]/40" data-id="element-743">{rec.synced}</span></div></div>
            </motion.button>;
        })}
          {filtered.length === 0 && <p className="text-[#8a8680]/50 text-sm text-center py-12" data-id="element-744">No records found.</p>}
        </div>
      </div>
    </div>;
}
function EditableSelect({
  value: initial,
  options
}: {
  value: string;
  options: string[];
}) {
  const [val, setVal] = useState(initial);
  const [open, setOpen] = useState(false);
  return <div className="relative" data-id="element-745">
      <button onClick={() => setOpen(!open)} className="flex items-center gap-1.5 px-2.5 py-1 rounded-md bg-[#252530] hover:bg-[#2a2a35] text-sm text-[#e8e4df] font-medium transition-colors" data-id="element-746">{val}<ChevronDown size={12} className="text-[#8a8680]" data-id="element-747" /></button>
      {open && <><div className="fixed inset-0 z-10" onClick={() => setOpen(false)} data-id="element-748" /><div className="absolute right-0 mt-1 rounded-lg shadow-xl overflow-hidden z-20 min-w-[140px] bg-[#252530] border border-[#8a8680]/10" data-id="element-749">{options.map(o => <button key={o} onClick={() => {
          setVal(o);
          setOpen(false);
        }} className="w-full text-left px-3 py-2 text-sm hover:bg-[#4a9a9a]/10 transition-colors" style={{
          color: val === o ? '#4a9a9a' : '#e8e4df'
        }} data-id="element-750">{o}</button>)}</div></>}
    </div>;
}
function EditableText({
  value: initial
}: {
  value: string;
}) {
  const [val, setVal] = useState(initial);
  const [editing, setEditing] = useState(false);
  if (editing) return <input type="text" value={val} onChange={e => setVal(e.target.value)} onBlur={() => setEditing(false)} onKeyDown={e => e.key === 'Enter' && setEditing(false)} className="bg-[#252530] text-[#e8e4df] text-sm font-medium px-2.5 py-1 rounded-md outline-none w-24 text-right" autoFocus data-id="element-751" />;
  return <button onClick={() => setEditing(true)} className="text-sm text-[#e8e4df] font-medium hover:bg-[#252530] px-2.5 py-1 rounded-md transition-colors" data-id="element-752">{val}</button>;
}
function RecordDetail({
  record,
  onBack
}: {
  record: DataRecord;
  onBack: () => void;
}) {
  const Icon = SOURCE_ICONS[record.source] || Database;
  const isJira = record.source === 'Jira';
  const [commentOpen, setCommentOpen] = useState(false);
  const [comment, setComment] = useState('');
  return <motion.div initial={{
    opacity: 0,
    x: 20
  }} animate={{
    opacity: 1,
    x: 0
  }} transition={{
    duration: 0.3
  }} className="min-h-[calc(100vh-56px)] text-[#e8e4df] selection:bg-[#4a9a9a]/30 pt-12 pb-32 px-6" data-id="element-753">
      <div className="max-w-[640px] mx-auto w-full" data-id="element-754">
        <button onClick={onBack} className="flex items-center gap-2 text-[#8a8680] hover:text-[#e8e4df] transition-colors mb-8" data-id="element-755"><ArrowLeft size={16} data-id="element-756" /><span className="text-sm" data-id="element-757">Data</span></button>
        <header className="mb-8 flex items-start justify-between" data-id="element-758">
          <div className="flex items-center gap-3" data-id="element-759"><div className="w-10 h-10 rounded-[12px] bg-[#252530] flex items-center justify-center shrink-0" data-id="element-760"><Icon size={18} className="text-[#8a8680]" data-id="element-761" /></div><div data-id="element-762"><h1 className="text-[20px] font-bold text-[#e8e4df] tracking-tight" data-id="element-763">{record.title}</h1><div className="flex items-center gap-2 mt-1" data-id="element-764"><span className="text-[13px] text-[#8a8680]/50" data-id="element-765">{record.source} {record.recordType}</span><span className="text-[#8a8680]/20" data-id="element-766">&middot;</span><span className="text-[13px] text-[#8a8680]/50" data-id="element-767">Synced {record.synced}</span></div></div></div>
          <button className="flex items-center gap-1.5 text-[#8a8680]/40 hover:text-[#4a9a9a] transition-colors text-[13px]" data-id="element-768"><ExternalLink size={14} data-id="element-769" />View original</button>
        </header>
        <div className="bg-[#1c1c22] rounded-[16px] p-6 shadow-xl shadow-black/20" data-id="element-770">
          {record.fields.map((field, i) => <div key={field.label} data-id="element-771">
              <div className="flex items-center justify-between py-4" data-id="element-772">
                <span className="text-sm text-[#8a8680]" data-id="element-773">{field.label}</span>
                {field.editable && field.options ? <EditableSelect value={field.value} options={field.options} data-id="element-774" /> : field.editable ? <EditableText value={field.value} data-id="element-775" /> : <span className="text-sm text-[#e8e4df] font-medium" data-id="element-776">{field.value}</span>}
              </div>
              {i !== record.fields.length - 1 && <div className="h-px bg-[#8a8680]/10" data-id="element-777" />}
            </div>)}
        </div>
        {isJira && <div className="mt-4" data-id="element-778">
            {!commentOpen ? <button onClick={() => setCommentOpen(true)} className="flex items-center gap-2 text-[13px] text-[#8a8680] hover:text-[#e8e4df] transition-colors" data-id="element-779"><MessageSquare size={14} data-id="element-780" />Add comment</button> : <div className="flex items-end gap-3" data-id="element-781">
                <textarea value={comment} onChange={e => setComment(e.target.value)} placeholder="Write a comment..." className="flex-1 bg-[#1c1c22] text-[#e8e4df] rounded-[12px] px-4 py-3 text-[14px] outline-none placeholder:text-[#8a8680]/40 focus:ring-1 focus:ring-[#4a9a9a]/30 resize-none min-h-[80px]" autoFocus data-id="element-782" />
                <button onClick={() => {
            setComment('');
            setCommentOpen(false);
          }} className="px-4 py-2.5 rounded-[10px] bg-[#4a9a9a] text-[#141418] text-[13px] font-medium hover:bg-[#5bb5b5] transition-colors shrink-0" data-id="element-783"><Send size={14} data-id="element-784" /></button>
              </div>}
          </div>}
      </div>
    </motion.div>;
}